/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 25/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 08/06/2026 | Lic. José Luis Aragón Cervantes  | Navegación controlada de cabeceros y abonos
*      3       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Integracion autonoma con Venta Super portatil
* --------------------------------------------------------------------------------------- */

import TextField from "../../ui/TextField";
import Autocomplete from "../../ui/Autocomplete";
import { apiObtenerListaPreventas, apiObtenerListaCotizaciones, apiConceptosYGruposList } from "../../../settings/ApiConfig"
import { useRequest } from "../../../context/System/RequestContext";
import { useLayout } from "../../../context/System/LayoutContext";

import React, { Fragment, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import KeyIcon from "@mui/icons-material/LockOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlineSharp";
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import SizeSoftXTablePaginadoFilter from "../../leyout/SizeSoftXTablePaginadoFilter"

import { Button, Box, MenuItem, Typography, InputAdornment } from "@mui/material";
import _ from 'lodash';
import SizeSoftXModalPortatil from "../leyout/SizeSoftXModalPortatil";

export default function ModalGenerarApartados(props) {
    const { openModalJalarPreventaCotizacion = false, handleCloseModalGenerarApartados, handleGenerarApartado, listaVentas } = props;

    const { GetRequest, PostRequest } = useRequest()
    const { handleOpenAlert } = useLayout();

    const [modalVisible, setModalVisible] = useState(false);
    const [internalOpen, setInternalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [folioSeleccionado, setFolioSeleccionado] = useState({});
    const [montoAbono, setMontoAbono] = useState(0);

    const [listaVentasData, setListaVentasData] = useState([]);

    const [detalles, setDetalles] = useState({
        concepto: null,
        grupo: null,
        nombrecliente: "",
        telefonocliente: ""
    });

    const [inputConcepto, setInputConcepto] = useState("");
    const [inputGrupo, setInputGrupo] = useState("");

    const [listaConceptos, setListaConceptos] = useState([{
        concepto: "",
        grupo: "",
    }]);

    const [listaConceptosAgrupados, setListaConceptosAgrupados] = useState([]);
    const [listaGrupos, setListaGrupos] = useState([]);
    const montoAbonoInputRefs = useRef([]);
    const conceptoInputRef = useRef(null);
    const grupoInputRef = useRef(null);
    const nombreClienteInputRef = useRef(null);
    const telefonoClienteInputRef = useRef(null);

    const focusAndSelect = (inputRef, delay = 0) => {
        setTimeout(() => {
            const input = inputRef?.current;
            if (!input) return;
            input.focus();
            input.select?.();
        }, delay);
    };

    const focusMontoAbonoByIndex = (index, delay = 0) => {
        setTimeout(() => {
            const input = montoAbonoInputRefs.current[index];
            if (!input) return;
            input.focus();
            input.select?.();
        }, delay);
    };


    useEffect(() => {
        if (openModalJalarPreventaCotizacion) {
            setInternalOpen(true);
            setIsSubmitting(false); // Enable the button when modal opens
            setTimeout(() => setModalVisible(true), 50);
            focusAndSelect(conceptoInputRef, 180);
        } else {
            setModalVisible(false);
            setTimeout(() => setInternalOpen(false), 500);
        }
    }, [openModalJalarPreventaCotizacion]);

    const handleAccionarRegistroApartado = async () => {
        if (isSubmitting) return;

        const concepto = (detalles.concepto || inputConcepto || "").trim();
        const nombre = (detalles.nombrecliente || "").trim();

        if (!concepto) {
            handleOpenAlert("Debe seleccionar o ingresar un concepto de apartado", "warning");
            return;
        }

        if (!nombre) {
            handleOpenAlert("Debe ingresar el nombre del cliente", "warning");
            return;
        }

        setIsSubmitting(true);
        try {
            await handleGenerarApartado(detalles, listaVentasData);
        } catch (error) {
            handleOpenAlert("Error al generar apartado: " + error.message);
        } finally {
            setIsSubmitting(false);
            handleCloseModalGenerarApartados();
        }
    };

    const handleChangeDetalles = (e) => {
        if (e.target.value === null)
            return;

        setDetalles(prevDetalles => ({
            ...prevDetalles,
            [e.target.name]: e.target.value
        }));
    };

    const handleChangeFolioSeleccionada = (x) => {
        setFolioSeleccionado(x);
    };

    // Función para agregar el campo montoAbono a cada elemento de listaVentas
    const addMontoAbonoToList = (list) => {
        return list.map(item => ({
            ...item,
            montoAbono: item.montoAbono || 0,  // Agrega el campo montoAbono si no existe
        }));
    };

    // Función para actualizar el monto abono en la lista de ventas
    const handleEditMontoAbono = (rowData, value) => {
        const updatedVentas = [...listaVentasData]; // Trabaja con listaVentasData
        const index = updatedVentas.findIndex(item => item.idpartida === rowData.idpartida); // Encuentra el índice usando un identificador único

        if (index !== -1) {
            updatedVentas[index].montoAbono = value; // Actualiza el valor
            setListaVentasData(updatedVentas); // Actualiza el estado de la lista
        }
    };

    const handleFormKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    };

    const handleHeaderNavigation = (e, nextRef) => {
        if (e.key !== "Enter" && e.key !== "Tab") return;
        e.stopPropagation();
        e.preventDefault();

        if (nextRef) {
            focusAndSelect(nextRef);
            return;
        }

        if (listaVentasData.length > 0) {
            focusMontoAbonoByIndex(0);
        }
    };

    const handleMontoAbonoKeyDown = (e, rowData) => {
        if (e.key !== "Enter" && e.key !== "Tab") return;
        e.stopPropagation();
        e.preventDefault();

        const currentIndex = listaVentasData.findIndex(item => item.idpartida === rowData.idpartida);
        const nextIndex = currentIndex + 1;

        if (nextIndex >= 0 && nextIndex < listaVentasData.length) {
            focusMontoAbonoByIndex(nextIndex);
            return;
        }

        handleAccionarRegistroApartado();
    };

    const handleObtenerListaConceptosSistema = async () => {
        const response = await GetRequest({
            url: apiConceptosYGruposList,
            loader: "Obteniendo listado de conceptos del sistema..."
        });

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        const listaX = response?.result || [];
        setListaConceptos(listaX);

        const listaConceptosAgrupadosX = listaX.reduce((acc, item) => {
            const { concepto } = item;
            if (!acc[concepto]) {
                acc[concepto] = item; // Guarda solo el primer elemento único
            }
            return acc;
        }, {});

        const conceptosAgrupadosArray = Object.values(listaConceptosAgrupadosX); //Esto convierte a un array el resultado

        setListaConceptosAgrupados(conceptosAgrupadosArray);
    };

    const handleCargarGruposPorConcepto = (conceptoSeleccionado) => {
        if (!conceptoSeleccionado) return;

        // Buscar los elementos que coincidan con el concepto seleccionado
        const listaGruposX = listaConceptos
            .filter(item => item.concepto && item.concepto.trim() && conceptoSeleccionado && conceptoSeleccionado.trim() && 
                        item.concepto.trim().includes(conceptoSeleccionado.trim())); // Filtrar por concepto

        const listaGruposAgrupadosX = listaGruposX.reduce((acc, item) => {
            const { grupo } = item;
            if (grupo && grupo.trim() && !acc[grupo]) {
                acc[grupo] = item; // Guarda solo el primer elemento único
            }
            return acc;
        }, {});

        const gruposArray = Object.values(listaGruposAgrupadosX);

        // Actualizar el estado con los grupos encontrados
        setListaGrupos(gruposArray);
    };

    const listaConceptosByOrder = listaConceptosAgrupados.slice().sort((a, b) => a.concepto.localeCompare(b.concepto));

    const listaGruposByOrder = listaGrupos.slice().sort((a, b) => a.grupo.localeCompare(b.grupo));

    useEffect(() => {
        const updatedVentas = addMontoAbonoToList(listaVentas);
        setListaVentasData(updatedVentas);

        setDetalles({
            concepto: null,
            grupo: null,
            nombrecliente: "",
            telefonocliente: ""
        });
        setInputConcepto("");
        setInputGrupo("");
    }, [listaVentas]);

    useEffect(() => {
        handleCargarGruposPorConcepto(detalles.concepto);
    }, [detalles.concepto]);

    useEffect(() => {
        if (listaConceptos.length === 1 && openModalJalarPreventaCotizacion) {
            handleObtenerListaConceptosSistema()
        }
    }, [openModalJalarPreventaCotizacion]);

    return (
        <SizeSoftXModalPortatil
            open={internalOpen}
            onClose={handleCloseModalGenerarApartados}
            aria-labelledby="menu-modal-title"
            aria-describedby="menu-modal-description"
        >
            <form onKeyDown={handleFormKeyDown}>
                <div className="containerPutApartados">
                    <Autocomplete
                        value={detalles.concepto}
                        onChange={(event, newValue) => {
                            setDetalles(prev => ({ ...prev, concepto: newValue }));
                            setInputConcepto(newValue || "");
                        }}
                        onInputChange={(event, newInputValue) => {
                            setInputConcepto(newInputValue);
                            setDetalles(prev => ({ ...prev, concepto: newInputValue }));
                        }}
                        inputValue={inputConcepto}
                        options={listaConceptosByOrder.map(concepto => concepto.concepto)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                inputRef={conceptoInputRef}
                                autoComplete="off"
                                label="Conceptos de apartado:"
                                onKeyDown={(e) => handleHeaderNavigation(e, grupoInputRef)}
                                sx={{ width: '240px' }}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PersonIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        )}
                        freeSolo
                    />
                    <Autocomplete
                        value={detalles.grupo}
                        onChange={(event, newValue) => {
                            setDetalles(prev => ({ ...prev, grupo: newValue }));
                            setInputGrupo(newValue || "");
                        }}
                        onInputChange={(event, newInputValue) => {
                            setInputGrupo(newInputValue);
                            setDetalles(prev => ({ ...prev, grupo: newInputValue }));
                        }}
                        inputValue={inputGrupo}
                        options={listaGruposByOrder.map(grupo => grupo.grupo)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                inputRef={grupoInputRef}
                                autoComplete="off"
                                label="Grupos por concepto:"
                                onKeyDown={(e) => handleHeaderNavigation(e, nombreClienteInputRef)}
                                sx={{ width: '240px' }}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PersonIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        )}
                        freeSolo
                    />
                    <TextField
                        inputRef={nombreClienteInputRef}
                        name="nombrecliente"
                        label="Nombre cliente:"
                        value={detalles.nombrecliente ? detalles.nombrecliente : ""}
                        onChange={handleChangeDetalles}
                        onKeyDown={(e) => handleHeaderNavigation(e, telefonoClienteInputRef)}
                        sx={{ width: '240px' }}
                        autoComplete="off"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PersonIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        inputRef={telefonoClienteInputRef}
                        name="telefonocliente"
                        label="Teléfono cliente:"
                        value={detalles.telefonocliente ? detalles.telefonocliente : ""}
                        onChange={handleChangeDetalles}
                        onKeyDown={(e) => handleHeaderNavigation(e, null)}
                        sx={{ width: '240px' }}
                        autoComplete="off"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PersonIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className="containerPassword">
                    <SizeSoftXTablePaginadoFilter
                        columns={[
                            { 
                                title: "Descripción", 
                                field: "descripcion",
                                cellStyle: { fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#fff9c4' }
                            },
                            { 
                                title: "Medida", 
                                field: "medida",
                                cellStyle: { fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#fff9c4' }
                            },
                            { 
                                title: "Costo venta", 
                                field: "costocliente",
                                cellStyle: { fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#fff9c4' }
                            },
                            { 
                                title: "Cantidad", 
                                field: "cantidad",
                                cellStyle: { fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#fff9c4' }
                            },
                                { 
                                    title: "AlmacenExhibidor", 
                                    field: "almacenexhibidor",
                                    cellStyle: { fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#fff9c4' }
                                },
                                { 
                                    title: "Prevendedor", 
                                    field: "vendedorpreventa",
                                    cellStyle: { fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#fff9c4' }
                                },
                                { 
                                    title: "Folio preventa", 
                                    field: "foliopreventa",
                                    cellStyle: { fontWeight: 'bold', fontSize: '1.1rem', backgroundColor: '#fff9c4' }
                                },
                            {
                                title: "Monto abono",
                                field: "montoAbono",
                                render: (rowData, index) => (
                                    <TextField autoComplete="off"
                                        inputRef={(el) => {
                                            const index = listaVentasData.findIndex(item => item.idpartida === rowData.idpartida);
                                            if (index >= 0) montoAbonoInputRefs.current[index] = el;
                                        }}
                                        value={rowData.montoAbono || 0}
                                        onFocus={(e) => e.target.select()}
                                        onChange={(e) => handleEditMontoAbono(rowData, e.target.value)}
                                        onKeyDown={(e) => handleMontoAbonoKeyDown(e, rowData)}
                                        type="text"
                                        inputMode="numeric"
                                        enterKeyHint="enter"
                                        sx={{ 
                                            width: '240px',
                                            '& .MuiInputBase-input': {
                                                fontWeight: 'bold',
                                                fontSize: '1.4rem',
                                            }
                                        }}
                                    />
                                ),
                            }
                        ]}
                        data={listaVentasData}
                        totalDeRegistros={listaVentasData.length}
                        id="idpartida"
                        row={folioSeleccionado}
                        setRow={handleChangeFolioSeleccionada}
                        fontSize="small"
                        rowsPerPageSet={50}
                        EspaciadorColumnas={2}
                    />
                </div>
                <div className="containerSubmit">
                    <Button className="validarFirmaButton"
                        style={{ width: '240px' }}
                        onClick={handleAccionarRegistroApartado}
                        disabled={isSubmitting || !((detalles.concepto || inputConcepto || "").trim()) || !((detalles.nombrecliente || "").trim())}
                    >
                        {isSubmitting ? "Procesando..." : "Generar apartado"}
                    </Button>
                </div>
            </form>
        </SizeSoftXModalPortatil>
    );
}
